const message = {
  ar: {
    title: "رياكت پرو سايد بار",
    sidebarTitle: "پرو سايد بار",
    description:
      "شريط جانبي مع قوائم منسدلة وعدد غير محدود من القوائم الفرعية المتداخلة",
    dashboard: "لوحة القيادة",
    components: "مكونات",
    dropdown: "اسقاط",
    submenu: "قائمة فرعية",
    multiLevel: "متعدد المستويات",
    collapsed: "انطوى",
    rtl: "ر ت ل",
    image: "صورة الخلفية",
    new: "جديد",
    withPrefix: "مع البادئة",
    withSuffix: "مع اللاحقة",
    viewSource: "عرض الكود",
  },
  en: {
    dashboard: "Dashboard",
    components: "Components",
    dropdown: "Dropdown",
    submenu: "Submenu",
    multiLevel: "Multi Level",
    collapsed: "Collapsed",
    rtl: "RTL",
    image: "Background image",
    new: "NEW",
    withPrefix: "With Prefix",
    withSuffix: "With Suffix",
    viewSource: "View Source",
    logOut: "Log Out",
    overview: "Overview",
    policy: "Policy",
    report: "Reports",
    company: "Company",
    userAccount: "User Account",
    history: "History",
    logo: "Insurance Portal",
    hello: "Hello ! Rusalba Ruiz",
    welcome: "Welcome Back To Your Insurance Portal",
    plan: "Your Plan : ",
    planType: " Free",
    newPlan: "Create New Plan",
    claim: "Claim",
    percClaim: "20% Safe On Your First Account",
    newBi: "NEWBIE20",
    copyC: "Copy Code",
  },
};

export default message;
